<div class="p-4">
    <div class="container">
        <h1><font color="#007bff">Welcome</font></h1>
        <p><font color="#007bff">Please contact Everleagues to establish the landing page for your company.</font></p>
        
    </div>
</div>